import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListFilter } from '../models/List.Event';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(filter: ListFilter): any {
    return this.http.post(`${environment.apiUrl}/ResEvent/ResGetAllEvents`, filter);
  }
  GetDetails(id: string) {
    return this.http.get(`${environment.apiUrl}/ResEvent/ResGetEventById?id=${id}`);
  }
  delete(id: string) {
    return this.http.get(`${environment.apiUrl}/ResEvent/ResDeleteEvent?id=${id}`);
  }
  saveRecord(data: any, photo: any) {
    const formData = new FormData();
    if (photo && photo.name) {
      formData.append('icon', photo, photo.name);
    }
    formData.append('data', JSON.stringify(data));
    if (data.id) {
      return this.http.post(`${environment.apiUrl}/ResEvent/ResEditEvent`, formData);
    } else {
      return this.http.post(`${environment.apiUrl}/ResEvent/ResNewEvent`, formData);
    }
  }
  getEventSlots(start: string, end: string) {
    return this.http.get(`${environment.apiUrl}/ResEvent/ResGetEventSlots?start=${start}&end=${end}`);
  }
}
